import { render, staticRenderFns } from "./MultiselectChoices.vue?vue&type=template&id=248f08b2&"
import script from "./MultiselectChoices.vue?vue&type=script&lang=js&"
export * from "./MultiselectChoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports